// src/hooks/useUpcomingBills.ts
import { useEffect, useState } from 'react';
import { Transaction } from '../types/Transaction';
import { useAuth } from '../context/AuthContext';
import { withForcedLedgerReadMode } from '../utils/ledgerReadMode';
import { authFetch } from '../lib/authFetch';

export const useUpcomingBills = () => {
  const { auth } = useAuth();
  const [upcoming, setUpcoming] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUpcoming = async () => {
      if (!auth?.token) return;

      setLoading(true);
      setError(null);

      try {
        const res = await authFetch(withForcedLedgerReadMode('/api/transactions/upcoming-bills?days=30'), {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });

        if (!res.ok) throw new Error('Failed to fetch upcoming bills');

        const data = await res.json();
        console.log(
          '📥 useUpcomingBills parsed data:',
          data.map((tx: any) => ({
            id: tx._id,
            desc: tx.description,
            isRecurring: tx.isRecurring,
            nextDueDate: tx.nextDueDate,
            date: tx.date,
            tags: tx.tags,
          }))
        );

        setUpcoming(data);
      } catch (err: any) {
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    fetchUpcoming();
  }, [auth?.token]);

  return { upcoming, loading, error };
};
